/* @flow */
import React, { Component } from 'react'

import './Heading.css'

type Props = {
	text: string,
}

export default class Heading extends Component<Props> {

  divider = () => {
    return(
      <svg width="75px" height="2px" viewBox="0 0 75 2" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
          <g id="Landing_Page_2.0" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-663.000000, -4348.000000)">
              <path d="M664.006711,4350 C663.45072,4350 663,4349.55228 663,4349 C663,4348.44772 663.45072,4348 664.006711,4348 L699.241611,4348 C699.797602,4348 700.248322,4348.44772 700.248322,4349 C700.248322,4349.55228 699.797602,4350 699.241611,4350 L664.006711,4350 Z M708.302013,4350 C707.746022,4350 707.295302,4349.55228 707.295302,4349 C707.295302,4348.44772 707.746022,4348 708.302013,4348 L722.899329,4348 C723.45532,4348 723.90604,4348.44772 723.90604,4349 C723.90604,4349.55228 723.45532,4350 722.899329,4350 L708.302013,4350 Z M731.456376,4350 C730.900384,4350 730.449664,4349.55228 730.449664,4349 C730.449664,4348.44772 730.900384,4348 731.456376,4348 L736.993289,4348 C737.54928,4348 738,4348.44772 738,4349 C738,4349.55228 737.54928,4350 736.993289,4350 L731.456376,4350 Z" id="Divider" fill={this.props.inverse ? '' : '#6ADFD4'} fillRule="nonzero"></path>
          </g>
      </svg>
    )
  }

  render() {
    return (
      <div className='Heading container'>
        <h2>{this.props.text}</h2>
        <div className="Heading--divider">
          {this.divider()}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/Widgets/Heading/Heading.js